// Vendors
import $ from 'jquery';

$('.wpcf7-field-groups')
  .on('wpcf7-field-groups/change', function () {
    $('.application-type').on('change', (event) => {
      event.preventDefault();
      const select_name = $(event.currentTarget).attr('name');
      const value = $(event.currentTarget).val();

      if (select_name) {
        const index = select_name.split('__')[1];
        const url_input = '.job-url__' + index;
        const file_input = '.job-file__' + index;
        const email_input = '.job-email__' + index;
        if (value == 'URL') {
          $(url_input).parent().parent().removeClass('u--display-none');
          $(file_input).parent().parent().addClass('u--display-none');
          $(email_input).parent().parent().addClass('u--display-none');
        } else if (value == 'File') {
          $(url_input).parent().parent().addClass('u--display-none');
          $(file_input).parent().parent().removeClass('u--display-none');
          $(email_input).parent().parent().addClass('u--display-none');
        } else if (value == 'Email') {
          $(url_input).parent().parent().addClass('u--display-none');
          $(file_input).parent().parent().addClass('u--display-none');
          $(email_input).parent().parent().removeClass('u--display-none');
        }
      }
    });
  })
  .trigger('wpcf7-field-groups/change');

// make job title required
$('.job-title').attr('required', true);

// custom validation
$('.job-title').on('change', (event) => {
  event.preventDefault();
  const value = $(event.currentTarget).val();

  if (value === '') {
    $(event.currentTarget).addClass('wpcf7-not-valid');

    $(event.currentTarget).after(
      '<span class="wpcf7-not-valid-tip" aria-hidden="true">The field is required.</span>'
    );
  } else {
    $(event.currentTarget).removeClass('wpcf7-not-valid');
    $(event.currentTarget).next().remove();
  }
});
